import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
@Injectable({
    providedIn: 'root',
})
export class AttendenceService extends ApiService {
    apiUrl = environment.apiUrl;
    // getKsaAttendence(country?) {
    //     return this.http.get(this.apiUrl + 'user/attendance', {params : {'country': country} });
    // }
    checkInUser(code : any) {
        this.updateUrlExtention();
        return this.http.get(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/getWithCreditTodaySessions?code=${code}`);
    }

    //update tainee membership credit
    updateTraineeMembershipCredit(body : any) {

        this.updateUrlExtention();
        return this.http.put(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/updateTraineeMembershipCredit`,body);
    }
    changeTraineeMembershipCreditNoShow(body : any) {
        this.updateUrlExtention();
        return this.http.put(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/changeTraineeMembershipCreditNoShow`,body);
    }
    unBanTraineeMembershipCredit(body : any) {
        this.updateUrlExtention();
        return this.http.put(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/unBanTraineeMembershipCredit`,body);
    }
    suspendTraineeMembershipCredit(body : any) {
        this.updateUrlExtention();
        return this.http.put(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/banTraineeMembershipCredit`,body);
    }
    getAllAttendance() {
        return this.http.get(this.apiUrl + `getAllAttendance?`);
    }
    getAttendence(date  : any) {
        // date forma 2019-09-29
        return this.http.get(this.apiUrl + 'getAllTraineesByDate?date=' + date);
    }
    setAttendance(body : any) {
        return this.http.post(this.apiUrl + 'attendance', body);

    }
    getReports() {
        return this.http.get(this.apiUrl + `trainers_report`);
    }
    changeUserCredit(body : any){
        this.updateUrlExtention();
        return this.http.put(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/changeUserCredit`,body)
    }
    changeUserAttendStatus(body : any){
        this.updateUrlExtention();
        return this.http.put(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/changeUserAttendStatus`,body)
    }
    scheduleSharedSession(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/scheduleSharedSession`,body)
    }
    getAvaSessions(traineeId : any, locationId : any, selectedDate : any, sessionId?: any){
        this.updateUrlExtention();
        let url = this.apiUrl+`backoffice${this.urlExtenssion}/trainee/availableUserSessions?trainee_id=${traineeId}&date=${selectedDate}&location_id=${locationId}`;
        if (sessionId) {
            url += `&session_id=${sessionId}`;
        }
        // Typed: untyped http.get() returns Observable<Object>, which TypeScript 6
        // will not narrow to any[] at the call site.
        return this.http.get<any[]>(url);
    }
    BookAvaSessions(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/scheduleSessionForTrainee`,body);
    }
    rescheduleSession(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/rescheduleSessionForTrainee`,body);
    }
    cancelSession(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/cancelSession`,body);
    }
    cancelSessions(traineeId: number, sessionIds: number[]){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/cancelSessions`, {
            trainee_id: traineeId,
            session_ids: sessionIds
        });
    }
    consultationCheck(body: any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/consultationCheck`,body);
    }
    blockSession(body: { session_id: number; trainee_id: number }) {
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/session/block`, body);
    }
    unblockSession(body: { session_id: number }) {
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/session/unblock`, body);
    }
    getBlockedSessionsForTrainee(traineeId: number) {
        this.updateUrlExtention();
        return this.http.get(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/blocked-sessions?trainee_id=${traineeId}`);
    }

    getSessionHistory(traineeId: number, params: { page?: number; per_page?: number } = {}) {
        this.updateUrlExtention();
        let query = `trainee_id=${traineeId}`;
        if (params.page) query += `&page=${params.page}`;
        if (params.per_page) query += `&per_page=${params.per_page}`;
        return this.http.get(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/getSessionHistory?${query}`);
    }
}
